import moment from 'moment';

export type BonusTimeLeft = 'imminent' | 'short' | 'medium' | 'long' | 'default';

/**
 * Determines the visual urgency category based on expiration date.
 */
export function getBonusTimeLeft(expirationDate: string): BonusTimeLeft {
  const now = moment();
  const expiration = moment(expirationDate);

  if (expiration.isSame(now, 'day')) {
    return 'imminent';
  }

  const daysLeft = getDaysLeft(expirationDate);

  if (daysLeft === 1) {
    return 'short';
  }

  if (daysLeft <= 3) {
    return 'medium';
  }

  if (daysLeft <= 7) {
    return 'long';
  }

  return 'default';
}

/**
 * Returns the number of full days remaining until expiration.
 */
export function getDaysLeft(expirationDateIso: string): number {
  return moment(expirationDateIso).startOf('day').diff(moment().startOf('day'), 'days');
}
